//  Switched the function to minutes
function formatMinutesToReadable(minutes) {
  if (!minutes || isNaN(minutes)) return "0min";

  const MINUTES_PER_DAY = 8 * 60;

  const dias = Math.floor(minutes / MINUTES_PER_DAY);
  const horas = Math.floor((minutes % MINUTES_PER_DAY) / 60);
  const mins = minutes % 60;

  let parts = [];

  if (dias > 0) parts.push(`${dias} dia${dias > 1 ? "s" : ""}`);
  if (horas > 0) parts.push(`${horas}h`);

  if (dias === 0 && mins > 0) parts.push(`${mins}min`);

  return parts.length ? parts.join(" ") : "0min";
}

export default formatMinutesToReadable;